export * from './widgets.actions';
export * from './profile.actions';
export * from './dashboard.actions';
export * from './course.actions';
export * from './instructorCourse.actions';


// WEBPACK FOOTER //
// src/main/content/dashboard/store/actions/index.js